export default "__VITE_ASSET__uwcqbLYi__"